import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Text,
  useToast
} from "@chakra-ui/react";

import { useLocation, useNavigate } from "react-router-dom";

import { useFormik } from "formik";
import TrQuizAnswers from "../../../../components/trainer/courses/assignments/QuizAnswers";

export default function TrQuiz() {
  const navigate = useNavigate();
  const location = useLocation();
  const { title } = location.state || {};
  const toast = useToast();
  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.topic) {
        errors.topic = "Role Name is required";
      }
      if (!values.discuss) {
        errors.discuss = "Role description is required";
      }

      return errors;
    },
    initialValues: {
      topic: "",
      discuss: "",
    },
    onSubmit: async (values) => {
      try {
      } catch (error) {
        toast({
          title: "Discussion",
          description: "Something went Wrong. Try again later",
          status: "error",
        });
      }
    },
  });
  return (
    <Box minHeight="100vh" bg="#F9F8F8">
      <Box position="fixed" zIndex="1" width="100%">
        <Box>
          <Flex
            px={12}
            height="70px"
            bg="#FFFFFF"
            color="#616161"
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text
              color="#959595"
              bg="white"
              mr="20px"
              width="40%"
              fontStyle="italic"
              fontSize="26px"
              variant="unstyled"
              size="sm"
            >
              {title}
            </Text>

            <HStack spacing={6}>
              <Button
                pb="50px"
                px="30px"
                mt="30px"
                type="submit"
                fontSize={16}
                variant="unstyled"
                onClick={() => {
                  navigate(-1);
                }}
                colorScheme="red"
                size="md"
              >
                Exit
              </Button>
              {/* <Button py='13px' px='30px' mt='30px' ml='20px' borderRadius='0px' type="submit" fontSize={16} colorScheme='red' size='md'>
                                Send
                            </Button> */}
            </HStack>
          </Flex>
        </Box>
      </Box>

      <Container
        width={"80%"}
        maxWidth={"94%"}
        px={0}
        pt="100px"
        pb="100px"
        right={0}
        bg="F9F8F8"
        mx="auto"
        height={"auto"}
        minHeight={"90vh"}
      >
        <Box bg="white">
          <TrQuizAnswers />
        </Box>
      </Container>
    </Box>
  );
}
